<div class="sidebar included">
	<app-sidebar-header [title]="'Corporate Balance'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flight"></app-flight-route>
		<div class="sidebar-flight-text">
			<h2 class="title-h2">Included</h2>
			<div class="border corp-balance--item">
				<div class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">Sonae</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12 corp-balance--label">
						<p>earning aprox. 5 € with this flight (4% of fare+YQ)</p>
					</div>
				</div>
			</div>
		</div>
		<div class="sidebar-flight-text border">
			<h2 class="title-h2">Earning Corporate Balance</h2>

			<div>
				<p>
					Sonae is a TAP Corporate Plus company. Congratulations! This means it  earns the maximum possible balance with each booking.<br>
					The more money the company spends in flights, the more baalance it earns.
				</p>
				<a href="https://www.tapcorporate.com/en-pt/earn-balance" target="_blank" class="link extras-feature__link link--external">Learn more about earning corporate balance</a>
			</div>
		</div>

		<app-compare-brands [feature]="feature" *ngIf="flight && !reviewFlights && !timeToThinkFlights"></app-compare-brands>


		<!-- <div class="compare-brand">
			<h2 class="title-h2">Compare Brands</h2>
			<div class="border compare-brand--item">
				<div class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding compare-brand--icon">
						<app-svg aria-hidden=true class="app-svg brand--discount" svg="sprite.svg#brand--discount" [alt]="'Discount brand'"></app-svg>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p>No balance earned</p>
					</div>
				</div>

				<div class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding compare-brand--icon">
						<app-svg aria-hidden=true class="app-svg brand--basic" svg="sprite.svg#brand--basic" [alt]="'Basic brand'"></app-svg>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p>aprox. 4 € with this flight (3% of fare+YQ)</p>
					</div>
				</div>

				<div class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding compare-brand--icon">
						<app-svg aria-hidden=true class="app-svg brand--classic" svg="sprite.svg#brand--classic" [alt]="'Classic brand'"></app-svg>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p>aprox. 5 € with this flight (4% of fare+YQ)</p>
					</div>
				</div>

				<div class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding compare-brand--icon">
						<app-svg aria-hidden=true class="app-svg brand--plus" svg="sprite.svg#brand--plus" [alt]="'Plus brand'"></app-svg>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p>aprox. 6 € with this flight (5% of fare+YQ)</p>
					</div>
				</div>
			</div>
		</div> -->
		<div class="sidebar-flight-text border">
			<p><a class="link extras-feature__link" aria-label="Close dialog" (click)="TAP_handleClose()" href="javascript:;"
					role="button">Close this window</a></p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
